import React, { useState, useEffect } from "react";
import {
  Drawer,
  Classes,
  FormGroup,
  InputGroup,
  Button,
  TextArea,
  Switch
} from "@blueprintjs/core";
import { FilledButton, TextButton } from "../buttons-20250224T111359Z-001/buttons";

export const DUE_IN_UNITS = {
  DAYS: 0,
  WEEKS: 1,
  MONTHS: 2,
};

export const DUE_IN_UNIT_OPTIONS = [
  { label: "Days", value: DUE_IN_UNITS.DAYS },
  { label: "Weeks", value: DUE_IN_UNITS.WEEKS },
  { label: "Months", value: DUE_IN_UNITS.MONTHS },
];

const TaskDrawer = ({ isOpen, onClose, task, onSave }) => {
  const [form, setForm] = useState({
    id: null,
    name: "",
    description: "",
    due_date: "",
    due_count: 0,
    due_unit: DUE_IN_UNITS.DAYS,
    // checklist: false,
    // is_attachment: false,
    attachment: null
  });

  useEffect(() => {
    if (task) {
      setForm({
        id: task.id || null,
        name: task.name || "",
        description: task.description || "",
        due_date: task.due_date || "",
        due_count: task.due_count || 0,
        due_unit: task.due_unit || DUE_IN_UNITS.DAYS,
        // checklist: task.checklist || false,
        // is_attachment: task.is_attachment || false,
        attachment: null
      });
    }
  }, [task]);

  const handleSave = () => {
    if (!form.name.trim()) return;
    onSave(form);
  };

  return (
    <Drawer
      portalContainer={document.body}
      isOpen={isOpen}
      onClose={onClose}
      title={form.id ? "Edit Task" : "New Task"}
      transitionDuration={5000}
      size={"50%"}
    >
      <div className={Classes.DIALOG_BODY}>

        {/* Task Name */}
        <FormGroup label="Task Name">
          <InputGroup
            placeholder="Enter task name"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
          />
        </FormGroup>

        {/* Description */}
        <FormGroup label="Description">
          <TextArea
            fill
            rows={3}
            placeholder="Enter description"
            value={form.description}
            onChange={(e) =>
              setForm({ ...form, description: e.target.value })
            }
          />
        </FormGroup>

        {/* Due Date */}
        {/* Due Duration */}
        <FormGroup label="Due Duration" className="due-duration-group">
          <div className="due-duration-container">

            {/* Stepper */}
            <div className="duration-stepper">
              <Button
                minimal
                icon="minus"
                className="stepper-btn"
                onClick={() =>
                  setForm({
                    ...form,
                    due_count: Math.max(1, form.due_count - 1)
                  })
                }
              />

              <span className="duration-value">
                {form.due_count}
              </span>

              <Button
                minimal
                icon="plus"
                className="stepper-btn"
                onClick={() =>
                  setForm({
                    ...form,
                    due_count: form.due_count + 1
                  })
                }
              />
            </div>

            {/* Unit Selector */}
            <div className="duration-unit-selector">
              {DUE_IN_UNIT_OPTIONS.map((unit) => (
                <Button
                  key={unit.value}
                  className={`duration-unit-btn ${form.due_unit == unit.value ? "active" : ""
                    }`}
                  onClick={() =>
                    setForm({
                      ...form,
                      due_unit: unit.value
                    })
                  }
                >
                  {unit.label}
                </Button>
              ))}
            </div>
          </div>

          {/* Helper Text */}
          <div className="duration-helper-text">
            Define how long the task should take to complete.
          </div>
        </FormGroup>

        {/* Checklist Switch */}
        {/* <FormGroup>
          <Switch
            checked={form.checklist}
            label="This task has checklist"
            onChange={(e) =>
              setForm({ ...form, checklist: e.target.checked })
            }
          />
        </FormGroup> */}

        {/* Attachment Switch */}
        {/* <FormGroup>
          <Switch
            checked={form.is_attachment}
            label="Requires Attachment"
            onChange={(e) =>
              setForm({ ...form, is_attachment: e.target.checked })
            }
          />
        </FormGroup> */}

        {/* Attachment Upload */}

        {/* <FormGroup label="Upload Attachment" labelFor="attachment-input">
          <label
            htmlFor={"attachment-input"}
            style={{
              cursor: "pointer",
              color: "#106ba3",
              fontSize: 14,
              fontWeight: 500
            }}
          >
            + Add file
          </label>

          <input
            id={"attachment-input"}
            type="file"
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files[0];
              setForm({ ...form, attachment: file });
            }}
          />
        </FormGroup> */}

        <div style={{ marginTop: "20px" }}>
        <FilledButton text={form.id ? "Update" : "Add"} onClick={handleSave} />
        <TextButton text="Cancel" onClick={onClose} />
      </div>

      </div>

      
    </Drawer>
  );
};

export default TaskDrawer;